(function() {
  'use strict';

  /*
    @param {Object} arg
    @param {JQuery} arg.container
    @param {string} arg.add_new_class
    @param {string} arg.row_class (optional, if we need a class to identify the 'tr' elements to count)
    @param {integer} arg.min_allowed (optional, defaults to 1)
  */
  window.applyMinimumRowsForForm = function(arg) {
    var min_allowed = Number.isInteger(arg.min_allowed) ? arg.min_allowed : 1;
    var rows = _findRelevantRows(arg.container, arg.row_class);
    if (rows.length <= min_allowed) { // add new (blank) row, if this is last
      arg.container.find('.add_new_' + arg.add_new_class + ':visible').trigger('click');
    }
  }

  window.removeClosestRow = function(event) {
    $(event.currentTarget).closest('tr').remove();
  }

  window.incrementSplitRowIndex = function(old_id, $clone, index_key, new_id) {
    $clone.attr('data-split-row-index', new_id);
    _findMatchesAndReplace({
      row: $clone,
      attribute: 'id',
      old_val: index_key + '_' + old_id + '_',
      new_val: index_key + '_' + new_id + '_',
      regex: new RegExp(index_key + '_' + old_id + '_')
    });
    _findMatchesAndReplace({
      row: $clone,
      attribute: 'name',
      old_val: '\['+index_key+'\]\['+old_id+'\]',
      new_val: '['+index_key+']['+new_id+']',
      regex: new RegExp('\\['+index_key+'\\]\\['+old_id+'\\]')
    });
  }

  window.checkTimeSinceLastClickAndContinue = function($elt_with_last_clicked, onSuccess) {
    var time = (new Date).getTime();
    if ((time - $elt_with_last_clicked.data('clicked')) < 1000) {
      return false; // milliseconds delay between clicks to avoid issues
    } else {
      $elt_with_last_clicked.data('clicked', time);
      onSuccess();
    }
  }

  function _findRelevantRows(container, row_class) {
    var selector = 'tr:visible';
    if(row_class !== undefined) {
      selector += '.' + row_class
    }
    return container.find(selector)
  }

  /*
  * Used to update the index in the id/name when we clone a row
  *
  * @param {Object} obj
  * @param {jQuery} obj.row - the splits row we're making changes to
  * @param {string} obj.attribute - name or id
  * @param {string} obj.old_val - the value we want to replace
  * @param {string} obj.new_val - the value we want to replace it with
  * @param {RegExp} obj.regex - regex to find the old val to replace
  */
  function _findMatchesAndReplace(obj) {
    $.each( obj.row.find('[' + obj.attribute + '*="' + obj.old_val + '"]'), function(_, elt) {
      $(elt).attr(
        obj.attribute,
        $(elt).attr(obj.attribute).replace(obj.regex, obj.new_val)
      );
    });
  }
})();
